import { apiClient } from '@slot-nx/core'
import { gameConfig } from '../../../config'
import { BetDetailResponse } from '../models/BetDetailResponse'
import { IBetDetailApi } from './IBetDetailApi'

export const betDetailApi: IBetDetailApi = {
  async getBetDetail(refNo: number, statementDate: string): Promise<BetDetailResponse> {
    const res = await apiClient.get<BetDetailResponse>(`${gameConfig.name}/player/betdetail`, {
      params: {
        refNo: refNo,
        statementDate: statementDate,
      },
    })
    return res.data
  },
}
